import { AgFinancingDebtType } from '@indigo-ag/schema';
import { debtTypesOptions } from 'shared';

export const getDebtTypeTranslated = (debtType: AgFinancingDebtType): string => {
  return debtType ? debtTypesOptions.find(d => d.value === debtType)!.name : '-';
};
